import { useState } from "react";
import { UseFormRegister } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { isHabitnuApp } from "../utils/white-label";
import LabelledField from "../ui/profile/components/labelled-field";

interface Props {
    name: string;
    label: string;
    placeholder?: string;
    errorMessage?: string;
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    register: UseFormRegister<any>;
}

export function PasswordField({
    name,
    label,
    placeholder = "",
    register,
    errorMessage,
}: Props) {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <LabelledField
            className="m-t-20 login-label"
            name={name}
            label={label}
            errorMessage={errorMessage}
        >
            <div style={{ marginBottom: "8px" }} />
            <div className="input-group">
                <input
                    {...register(name)}
                    type={showPassword ? "text" : "password"}
                    className="form-control field-height password-field password-text"
                    placeholder={placeholder}
                />
                <FontAwesomeIcon
                    icon={showPassword ? faEye : faEyeSlash}
                    className="password-eye"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                        color: isHabitnuApp() ? "#00087a" : "inherit",
                        marginLeft: "10px",
                        fontSize: "20px",
                    }}
                />
            </div>
        </LabelledField>
    );
}
